namespace RedBullMOBILE360.Administration {
    export interface DbLinkMapRow {
        Id?: number;
        LinkAlias?: string;
        ReplaceBy?: string;
    }

    export namespace DbLinkMapRow {
        export const idProperty = 'Id';
        export const nameProperty = 'LinkAlias';
        export const localTextPrefix = 'Administration.DbLinkMap';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            LinkAlias = "LinkAlias",
            ReplaceBy = "ReplaceBy"
        }
    }
}
